export default "__VITE_ASSET__CTnbAvvm__"